import type { SignupSchool } from '../../types/signup';
import { describeSchool, formatAnnualPrice } from './signupFormat';

/** The school the email resolved to, and what a program there costs. */
export const SignupSchoolSummary = ({
  school,
  annualPriceCents,
  currency,
}: {
  school: SignupSchool;
  annualPriceCents: number | null;
  currency: string;
}) => {
  const details = describeSchool(school);

  return (
    <div className="signup-school" data-testid="signup-school">
      <p className="signup-school__name">{school.name}</p>
      {details && <p className="signup-school__details">{details}</p>}
      {annualPriceCents !== null && (
        <p className="signup-school__price" data-testid="signup-price">
          {formatAnnualPrice(annualPriceCents, currency)}
        </p>
      )}
    </div>
  );
};
